import { BankingValueObjectsCardTypeEnum } from 'generated/resources/graphql'

export const isPhysical = (card: { type: BankingValueObjectsCardTypeEnum }): boolean => {
  return card.type === 'physical'
}
